//Get Reducer Call--->
export const getCustomerRequest = (page: number, size: number, search: string) => ({
    type: 'GET_CUSTOMER_REQUEST',
    payload: { page, size, search },
});

export const getCustomerSuccess = (data: any) => ({
    type: 'GET_CUSTOMER_SUCCESS',
    payload: { data },
});

export const getCustomerFailure = (data: string) => ({
    type: 'GET_CUSTOMER_FAILURE',
    payload: { data },
});

export const resetGetCustomer = () => ({
    type: 'RESET_GET_CUSTOMER',
});

//Create Reducer Call--->
export const createCustomerRequest = (data: any) => ({
    type: 'CREATE_CUSTOMER_REQUEST',
    payload: data,
});

export const createCustomerSuccess = (data: any) => ({
    type: 'CREATE_CUSTOMER_SUCCESS',
    payload: { data },
});

export const createCustomerFailure = (data: string) => ({
    type: 'CREATE_CUSTOMER_FAILURE',
    payload: { data },
});

export const resetCreateCustomer = () => ({
    type: 'RESET_CREATE_CUSTOMER',
});

//Update Reducer Call--->
export const updateCustomerRequest = (data: any, id: string) => ({
    type: 'UPDATE_CUSTOMER_REQUEST',
    payload: { data, id },
});

export const updateCustomerSuccess = (data: any) => ({
    type: 'UPDATE_CUSTOMER_SUCCESS',
    payload: { data },
});

export const updateCustomerFailure = (data: string) => ({
    type: 'UPDATE_CUSTOMER_FAILURE',
    payload: { data },
});

export const resetUpdateCustomer = () => ({
    type: 'RESET_UPDATE_CUSTOMER',
});
//Delete Reducer Call--->
export const deleteCustomerRequest = (id: string) => ({
    type: 'DELETE_CUSTOMER_REQUEST',
    payload: { id },
});

export const deleteCustomerSuccess = (data: any) => ({
    type: 'DELETE_CUSTOMER_SUCCESS',
    payload: { data },
});

export const deleteCustomerFailure = (data: string) => ({
    type: 'DELETE_CUSTOMER_FAILURE',
    payload: { data },
});

export const resetDeleteCustomer = () => ({
    type: 'RESET_DELETE_CUSTOMER',
});
